export default __webpack_public_path__ + "static/media/home_art.c3cce54a.webp";